import React from 'react'
import { Trans } from '@lingui/react/macro'

import style from './index.module.scss'


import { cls } from 'tagged-classnames-free';
import Link from '@/components/Link';
export interface IRelatedArticlesSidebarProps {
  sidebarTitle?: string
  className?: string

  sidebarArticles?: {
    h1: string
    url: string
    description: string
  }[]
}

const RelatedArticlesSidebar: React.FC<IRelatedArticlesSidebarProps> = (
  props,
) => {
  const { sidebarArticles, className } = props

  if (!sidebarArticles?.length) {
    return null
  }
  return (
    <div
      className={cls`
        text-f-text-secondary 
        border-f-border 
        sticky top-20 h-fit 
        w-full rounded
        border p-2 md:p-3 lg:w-[224px]
        ${className}
      `}
    >
      <p className='pb-3 text-lg font-semibold'>
        <Trans>Related Articles</Trans>
      </p>
      <div
        className={cls`
          space-y-3 rounded-sm text-sm
           ${
             sidebarArticles.length > 6 &&
             'h-[350px] overflow-y-auto md:h-[230px]'
           }
           ${style.sidebar}
        `}
      >
        {sidebarArticles.map((item) => (
          <Link
            key={item.url}
            href={item.url}
            className='hover:text-f-primary block'
          >
            {item.h1}
          </Link>
        ))}
      </div>
    </div>
  )
}
export default RelatedArticlesSidebar
